// Risoluzione del timeout di inattività (issue #3301, FR-002/FR-003/FR-004).
//
// Il valore viaggia su due canali distinti, perché AccountOrganizzazione (LocalApi) e Operatore
// (AuthApi) vivono su due database separati e nessuno dei due servizi può leggere l'altro:
//   - globale  → AuthenticateResponse.inactivityTimeoutMinutes (AuthSettings dell'AuthApi)
//   - override → MyAccountSettings.inactivityTimeoutMinutes (membership operatore/organizzazione)
// La correlazione avviene qui, sul client, dove l'enforcement già risiede (feature 102).

/**
 * @param override valore della membership: null/undefined = eredita il globale, 0 = disattivato
 * @param global valore globale distribuito dall'AuthApi
 * @returns minuti di inattività prima del logout automatico; 0 = logout automatico disattivato
 */
export function resolveInactivityTimeout(override?: number | null, global?: number | null): number {
  // ⚠️ `??` e NON `||`: con `||` il valore 0 — "logout disattivato per questo operatore" —
  // collasserebbe sul globale, invertendo esattamente l'intenzione dell'utente.
  return override ?? global ?? 0;
}
